module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-Bold.aae11ff9.woff";